// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2EJ10","vLegacy":"SelectSecondary_vLegacy__k0JH1","error":"SelectSecondary_error__1xYoY","disabled":"SelectSecondary_disabled__1VE4i"};